import Vue from 'vue';
import { findIndex, each } from 'lodash';

export const updateArrayItemByID = (array, item) => {
  const index = findIndex(array, o => o.id === item.id);
  Vue.set(array, index, item);
};

export const removeArrayItemByID = (array, id) => {
  const index = findIndex(array, o => o.id === id);
  Vue.delete(array, index);
};

export const removeArrayItemsFromNestedListByID = (list, id) => {
  each(list, (array) => {
    const index = findIndex(array.items, o => o.id === id);
    Vue.delete(array.items, index);
  });
};

export const updateArraySequence = (array, key) => {
  each(array, (item, index) => {
    Vue.set(item, key, index);
  });
};



// WEBPACK FOOTER //
// ./src/utils/array.js